module.exports = __webpack_public_path__ + "static/media/modalDelete.4a4b96fb.svg";